import { render, staticRenderFns } from "./PagerControl.vue?vue&type=template&id=dbfa4b7a"
import script from "./PagerControl.vue?vue&type=script&lang=js"
export * from "./PagerControl.vue?vue&type=script&lang=js"
import style0 from "./PagerControl.vue?vue&type=style&index=0&id=dbfa4b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports